import { CountryMessage } from '../../../../types/CountryMessage';
import { PageMessage } from '../../../../types/PageMessage';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export const getEnums = async (): Promise<any> => {
    const response = await authorizedAxiosInstance.get('/v1/enums');

    return response.data;
};

export const getCountries = async (searchQuery: string, page?: number): Promise<PageMessage<CountryMessage>> => {
    const response = await authorizedAxiosInstance.get('/v1/country', {
        params: {
            searchQuery: searchQuery?.trim() || undefined,
            page,
        },
    });

    return response.data;
};

export const getCountryList = async (): Promise<CountryMessage[]> => {
    const response = await authorizedAxiosInstance.get(`v1/country/list`);

    return response.data;
};
